export default "__VITE_ASSET__C$tGSm0K__"